import {
  Button,
  Container,
  Grid,
  makeStyles,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Toolbar,
  Typography,
} from "@material-ui/core";
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Autocomplete } from "@material-ui/lab";
import LoadingComponent from "../CommonComponents/loadinComponent";
import TopView from "../CommonComponents/topView";
import moment from "moment/moment";
import { Link } from "react-router-dom";
import GetAppIcon from "@material-ui/icons/GetApp";
// import ChainagesAdd from "../../ChainagesAdd.xlsx";
import { useRef } from "react";
import AlertDialog from "./requesterModal";
import { VehicleAction } from "../../actions/vehicle";
import { SiteAction } from "../../actions/site";

import config from "../../config/config";
import { DieselRequestAction } from "../../actions/DieselRequest";
import chargeSample from "../../DieselRequestVehicleAdd.xlsx";
import VehicleAddExcel from "./dieserequestExcel";
import ExportReport from "../CommonComponents/Export"
import ExportPdf from "../CommonComponents/exportPdf";
import InfoIcon from "@material-ui/icons/Info";
import DieselInfoModal from "./dieselinfoModal";
import { SubscriptionsOutlined } from "@material-ui/icons";
import ColorLevel from "./ColorLevel";
import ColorLabel from "../CommonComponents/colorLabel";
const requestHeader = [
  { id: "SrNo", numeric: false, disablePadding: true, label: "Sr No" },
  {
    id: "1",
    numeric: false,
    disablePadding: true,
    label: "Vehicle Number",
  },
  {
    id: "2",
    numeric: false,
    disablePadding: true,
    label: "Site",
  },
  {
    id: "3",
    numeric: true,
    disablePadding: false,
    label: "Status",
  },
 {
    id: "4",
    numeric: false,
    disablePadding: true,
    label: "Issued Diesel (Ltr.)",
  },
  {
    id: "4",
    numeric: false,
    disablePadding: true,
    // label: "Actual Issued Qty(Ltr.)",
    label:"Actual Issued (Ltr.)"
  },
  {
    id: "5",
    numeric: false,
    disablePadding: true,
    label: "Request Info",
  },
  {
    id: "6",
    numeric: false,
    disablePadding: true,
    label: "Approve Info",
  },

  {
    id: "7",
    numeric: false,
    disablePadding: true,
    label: "Issue Info",
  },
  {
    id: "8",
    numeric: true,
    disablePadding: false,
    label: "Action",
  },
];

const requestHeaderForAdmin = [
  { id: "SrNo", numeric: false, disablePadding: true, label: "Sr No" },
  {
    id: "1",
    numeric: false,
    disablePadding: true,
    label: "Vehicle Number",
  },
  {
    id: "2",
    numeric: false,
    disablePadding: true,
    label: "Site",
  },
  {
    id: "3",
    numeric: true,
    disablePadding: false,
    label: "Current status",
  },
 {
    id: "4",
    numeric: false,
    disablePadding: true,
    label: "Issued Diesel Qty(Ltr.)",
  },

  {
    id: "5",
    numeric: false,
    disablePadding: true,
    label: "Request Info",
  },
  {
    id: "6",
    numeric: false,
    disablePadding: true,
    label: "Approve Info",
  },

  {
    id: "7",
    numeric: false,
    disablePadding: true,
    label: "Issue Info",
  },
  {
    id: "8",
    numeric: true,
    disablePadding: false,
    label: "Action",
  },
];
const EnhancedTableHead = (props) => {

// if(JSON.parse(localStorage.getItem("data")).userType!=="ADMIN"){
//   requestHeader.splice(4,-5);
//   // requestHeader[5].remove();
  
// }
console.log(requestHeader)
  return (
    <TableHead>
      <TableRow>
        {(JSON.parse(localStorage.getItem("data")).userType!=="ADMIN"?requestHeaderForAdmin:requestHeader).map((head) => {
          return (
            <TableCell
              style={{ fontWeight: 700, background: "rgb(233 241 241)" }}
              key={head.id}
            >
              {" "}
              {head.label}
            </TableCell>
          );
        })}
      </TableRow>
    </TableHead>
  );
};

EnhancedTableHead.prototype = {
  // classes: PropTypes.object.isRequired,
};

const EnhancedTableToolbar = (props) => {
  const {
    numSelected,
    getVehicleId,
    // getSiteid,
    getDateFilter,
    vehicleList,
    vehicleId,
    fromdate,
    ToDate,
    onSubmitHandler,
    setDeviceId,
    siteList,
    getSiteID,
    getVehicleTypeId,
    vehicleTypeList,
    vehicleTypeId,
    siteId,
    getdate,
    verificationStatusArray,
    getStatusValue
    
  } = props;
  console.log(siteList);
  return (
    <Grid container  
    item
    spacing={1}
    justifyContent="center"
    // flexGrow={1}
    // flexWrap="wrap"
    >
    {/* <Grid items xs={2} style={{ margin: "0 25px" }}>
        <Autocomplete
          style={{ backgroundColor: "white" }}
          //id="combo-box-demo"
          id="header"
          getOptionLabel={(option) => option.name}
          className="user"
          options={verificationStatusArray || []}
          // disableClearable
          disablePortal={true}
          filterSelectedOptions
          getOptionSelected={(option, value) =>
            option.number === value.number
          }
          onChange={(event, value) => getStatusValue(value)}
          renderInput={(params) => (
            <TextField
              {...params}
              value={vehicleId}
              margin="dense"
              variant="outlined"
              placeholder="Request Status"
            />
          )}
        />
      </Grid> */}
    {/* <Grid
      container
      direction="row"
      justifyContent="flex-start"
      alignItems="center"
      items
      sx={4}
      
    >
     
    </Grid> */}
    {/* <Grid 

    // w-100
    // direction="row"      
      // alignItems="center" 
      // justifyContent="center"
      // items xs={12}
      style={{ width:"100%",margin: "0 5px",backgroundColor: "blue",width:"90%" }}
       > */}
        

    <Grid item xs={2}  >
        <Autocomplete
          style={{backgroundColor: "white"}}
          //id="combo-box-demo"
          id="header"
          getOptionLabel={(option) => option.name}
          className="user"
          options={vehicleTypeList || []}
          // disableClearable
          disablePortal={true}
          filterSelectedOptions
          getOptionSelected={(option, value) =>
            option.name === value.name
          }
          onChange={(event, value) => getVehicleTypeId(value)}
          renderInput={(params) => (
            <TextField
              {...params}
              value={vehicleTypeId}
              margin="dense"
              variant="outlined"
              placeholder="Vehicle Type"
            />
          )}
        />
      </Grid>
      <Grid item xs={2} >
        <Autocomplete
          style={{ backgroundColor: "white",  }}
          //id="combo-box-demo"
          id="header"
          getOptionLabel={(option) => option.name}
          className="user"
          options={verificationStatusArray || []}
          // disableClearable
          disablePortal={true}
          filterSelectedOptions
          getOptionSelected={(option, value) =>
            option.name === value.name
          }
          onChange={(event, value) => getStatusValue(value)}
          renderInput={(params) => (
            <TextField
              {...params}
            
              margin="dense"
              variant="outlined"
              placeholder="Request Status"
            />
          )}
        />
      </Grid>
      <Grid item xs={2}>
        <Autocomplete
          style={{ backgroundColor: "white",  }}
          //id="combo-box-demo"
          id="header"
          getOptionLabel={(option) => option.name}
          className="user"
          options={siteList || []}
          // disableClearable
          disablePortal={true}
          filterSelectedOptions
          getOptionSelected={(option, value) =>
            option.name === value.name
          }
          onChange={(event, value) => getSiteID(value)}
          renderInput={(params) => (
            <TextField
              {...params}
            
              margin="dense"
              variant="outlined"
              placeholder="Select Site"
            />
          )}
        />
      </Grid>
      <Grid item xs={2}>
        <Autocomplete
          style={{ backgroundColor: "white", }}
          //id="combo-box-demo"
          id="header"
          getOptionLabel={(option) => option.number}
          className="user"
          options={vehicleList || []}
          // disableClearable
          disablePortal={true}
          filterSelectedOptions
          getOptionSelected={(option, value) =>
            option.number === value.number
          }
          onChange={(event, value) => getVehicleId(value)}
          renderInput={(params) => (
            <TextField
              {...params}
              value={vehicleId}
              margin="dense"
              variant="outlined"
              placeholder="Select Vehicle"
            />
          )}
        />
      </Grid>
      <Grid item xs={2}>
        <TextField
          style={{ backgroundColor: "white" }}
          id="fromdate"
          name="fromDate"
          type="date"
          variant="outlined"
          value={fromdate}
          onChange={getDateFilter}
        ></TextField>
      </Grid>
      <Grid item xs={2}>
        <TextField
          style={{ backgroundColor: "white" }}
          id="fromdate"
          name="toDate"
          type="date"
          variant="outlined"
          value={ToDate}
          onChange={getDateFilter}
        ></TextField>
      </Grid>
    {/* </Grid> */}
  </Grid>
  );
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

/* =================CUSTOM STATUS BUTTON====================== */

//  const useStyles = makeStyles({
//     statusButton:{
//         color:"white",
//         background:props=>props.btnType=="Approve"?"green":props.btnType=="Reject"?"red":props.btnType=="Issue"?"#2e475f":"white",
//         borderRadius:".2rem",
//         fontSize:".8rem"
//     },
//     root: {
//       width: "100%",
//       marginTop: "7rem",
//     },
//     paper: {
//       width: "100%",
//       marginBottom: theme.spacing(2),
//     },

//  })

const useStyles = makeStyles((theme, Button) => ({
  root: {
    width: "100%",
    marginTop: "7rem",
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },

  backgroundGreen: {
    color: "white",
    background: "green",

    borderRadius: ".2rem",
    fontSize: ".8rem",
    marginRight: ".3rem",
    padding: "2px 5px",
    "&:hover": {
      backgroundColor: "#2e475f",
    },
  },

  backgroundRed: {
    color: "white",
    background: "red",
    borderRadius: ".2rem",
    fontSize: ".8rem",
    marginRight: ".3rem",
    padding: "2px 5px",
    "&:hover": {
      backgroundColor: "#2e475f",
    },
  },
  backgroundIssue: {
    color: "white",
    background: "#2e475f",
    borderRadius: ".2rem",
    fontSize: ".8rem",
    marginRight: ".3rem",
    padding: "2px 5px",
    "&:hover": {
      backgroundColor: "#2e475f",
    },
  },
    backgroundSync: {
      color: "white",
      background: "#2e475f",
      borderRadius: ".2rem",
      fontSize: ".8rem",
      marginRight: ".3rem",
      padding: "2px 5px",
      "&:hover": {
        backgroundColor: "#2e475f",
      },
  },
}));
const StatusButton = (props) => {
  console.log(props.btnType);
  const { openExcelImportModal, Type } = props;
  const classes = useStyles(props);
  return (
    <Button
      disableElevation
      disableRipple
      // style={{color:"#fff"}}

      className={
        props.btnType === "Approve"
          ? classes.backgroundGreen
          : props.btnType === undefined
          ? classes.backgroundRed
          : props.btnType === "Issue"
          ? classes.backgroundIssue
          : props.btnType=="sync"
          ? classes.backgroundSync
          :""
      }
      onClick={() => openExcelImportModal(Type)}
    >
      {props.children}
    </Button>
  );
};
/* =================END CUSTOM STATUS BUTTON=================== */
export const DieselRequestList = () => {
  const classes = useStyles();
  const fileRef = useRef(null);

  const [isLoading, setIsLoading] = useState(false);

  const [ToDate, setToDate] = useState(moment(new Date()).format("YYYY-MM-DD"));
  const [fromdate, setFromDate] = useState(
    moment(new Date()).format("YYYY-MM-DD")
  );
  const [vehicleId, setVehicleId] = useState("");
  const [deviceId, setDeviceId] = useState();
  const [tablerowdata, setTableRowData] = useState([]);
  const [selected, setSelected] = useState([]);
  const [permissionAccess, setPermissionAccess] = React.useState(
    JSON.parse(localStorage.getItem("data"))
  );
  const [openAlert, setOpenAlert] = useState(false);
  const [Type, setType] = useState();
  const [vehicleList, setVehicleList] = useState([]);
  const [siteList, setSiteList] = useState([]);
  const [tankerCapacity, setTankerCapacity] = useState("");
  const [Diesel, setDisel] = useState();
  const [currentFuel, setCurrentFuel] = useState("");
  const [RequestedFuel, setRequestedFuel] = useState();
  const [approvedFuel, setApprovedFuel] = useState("");
  const [Remarkvalue, setRemarkValue] = useState("");
  const [fileName, setFileName] = useState("");
  const [issuedFuelQuantity, setiSsuedFuelQuantity] = useState("");
  const [siteId, setSiteId] = useState("");
  const [selectedRow, setSelectedRow] = useState([]);
  const [openExcelImport, setOpenExcelImport] = useState(false);
  const [loading, setLoading] = useState(true);
  const [issuedFuel, setIssuedFuel] = useState("");
 
  const [pageNo, setPageNo] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(10);
  const [totalPages, setTotalPages] = React.useState(0);
  const [siteIdBool, setSiteIdBool] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [tankerCapacityvalue, setTankerCapacityvalue] = useState("");
  const [currentFuelValue,setCurrentFuelValue]=useState("");
  const[Green,setGreen]=useState("green")
  const [redcolor,setRedcolor]=useState("red")
  const[Yellow,setYellow]=useState("blue")
 
  const [date, setDate] = useState("");
  const [isManualSync,setisManualSync]=useState(false)

  // const [fromdateForModal, setFromdateForModal] = useState(
  //   moment(new Date()).format("YYYY-MM-DD")
  // );
  const newDate = new Date();
  const nowdate = moment(
    moment(newDate.setHours(23, 59)).format("YYYY-MM-DD")
  );
  const [todayDate, setTodayDate] = useState(
    moment(newDate).format("YYYY-MM-DD")
  );
  // const [fromdate, setFromDate] = useState(
  //   moment(newDate.setHours(0, 0)).format("YYYY-MM-DDTHH:mm")
  // );
  // const [exportData, setExportData] = React.useState([]);

  const [openInfoModal, setOpenInfoModal] = useState(false);
  const [infoModalTitle, setInfoModalTitle] = useState("");

  const [vehicleTypeList,setVehicleTypeList]=useState([])
  const [fromdateForModal,setFromdateForModal]= useState(moment(new Date()).format("YYYY-MM-DD"));
  
  const [vehicleTypeId,setVehicleTypeId]=useState("");
  const [verificationStatus,setVerificationStatus]=useState("")
  const [dieselModuleData,setDieselModuleData]=useState([])
  const [exportDataPdf,setExportDataPdf]=useState([]);
  const [exportData,setExportData]=useState([])


console.log(tablerowdata)

  /* =====================VERIFICATION STATUS===================== */

  const verificationStatusArray = [
    {name:"Requested", value:"REQUESTED"},
    {name:"Approved", value:"APPROVED"},
    {name:"Issued", value:"ISSUED"},

    { name: JSON.parse(localStorage.getItem("data")).userType=="ADMIN"?"Issued-Pending":"", value:  "ISSUED-PENDING"},
    { name:JSON.parse(localStorage.getItem("data")).userType=="ADMIN"? "Issued-Authorized":"", value:  "ISSUED-CONFIRMED" },
    { name: JSON.parse(localStorage.getItem("data")).userType=="ADMIN"?"Issued-Unauthorized":"", value:  "ISSUED-UNACEPTABLE"},

  ]


  function getStatusValue(data){
    if(data!=null){
      setVerificationStatus(data)
      // setPageNo(0);
      // setPageSize(10);
      // setSiteIdBool(true)

    }else{
      setVerificationStatus()
      // setPageNo(0);
      // setPageSize(0);
      // setSiteIdBool(false)
    }
  }
/* ==============================END==================================== */
  function getSiteID(data){
    if(data!=null){
      setSiteId(data.id)
      // setPageNo(0);
      // setPageSize(10)
      // setSiteIdBool(true)



    }else{
      setSiteId("")
      // setPageNo(0);
      // setPageSize(0)
      // setSiteIdBool(false)

    }
    // console.log(data);
  }
  function getVehicleTypeId(data){
    if(data!=null){
      setVehicleTypeId(data)

    }else{
      setVehicleTypeId("")
    }
    console.log(data)
  }
  function handlemodal() {
    setOpenExcelImport(false);

    document.getElementById("mainSubmit").click();
  }


  /* ====================SELECT ROW HANDLER========================== */
  const rowSelectHandler = (event, row) => {
    const selectedIndex = selected.indexOf(row);
    let newSelectedRows = [];
    if (selectedIndex == -1) {
      newSelectedRows.concat(row);
    }

    setSelected(newSelectedRows);
  };
  /* =======================END ELECT ROW HANDLER==================== */

  let createButton = true;
  let DirectIssueButton = true;
  let approveRejectButton = true;
  let issueButton = true;
  
  const viewDieselRequestPermission =
    permissionAccess.webPermissionDTOList.filter((ele) => {
      return ele.name === "FUEL_FILL_REQUEST_GET" && ele.forWeb == true;
    });
  const createRequestPermission = permissionAccess.webPermissionDTOList.filter(
    (ele) => {
      return ele.name === "FUEL_FILL_REQUEST_CREATE" && ele.forWeb == true;
    }
  );
  const approveRequestPermission = permissionAccess.webPermissionDTOList.filter(
    (ele) => {
      return ele.name === "FUEL_FILL_REQUEST_APPROVE" && ele.forWeb == true;
    }
  );
  const issueRequestPermission = permissionAccess.webPermissionDTOList.filter(
    (ele) => {
      return ele.name === "FUEL_FILL_REQUEST_ISSUE" && ele.forWeb == true;
    }
  );
  const manualSyncPermission = permissionAccess.webPermissionDTOList.filter(
    (ele) => {
      return ele.name === "FILL_MANUAL_SYNC" && ele.forWeb == true;
    }
  );

  const directIssueRequestPermission =
    permissionAccess.webPermissionDTOList.filter((ele) => {
      return (
        ele.name === "FUEL_FILL_DIRECT_ISSUE_REQUEST_CRAETE" &&
        ele.forWeb == true
      );
    });

  console.log(
    approveRequestPermission,
    createRequestPermission,
    issueRequestPermission,
    directIssueRequestPermission
  );

//====================date Filter ==========================//

const getFilterDate = (data) => {
  ////debugger;
  let Todate = 0;
  let Fromdate = 0;
  var d = new Date();
  let selectedFrom;
  let selectedTo;
  if (data == "Today") {
    selectedFrom = moment().startOf("day");
    selectedTo = moment().endOf("day");
    setFromDate(moment(selectedFrom).format("YYYY-MM-DD"));
    setTodayDate(moment(selectedTo).format("YYYY-MM-DD"));
  } else if (data == "Yesterday") {
    selectedFrom = moment().subtract(1, "day").startOf("day");
    selectedTo = moment().subtract(1, "day").endOf("day");
    setFromDate(moment(selectedFrom).format("YYYY-MM-DD"));
    setTodayDate(moment(selectedTo).format("YYYY-MM-DD"));
  } 
};


const getdate=((data)=>{
  if (data) {
    setDate(data);
    getFilterDate(data);
  } else if (!data) {
    console.log("no time filter is pressed!!!");
  } else {
    setDate("");
  }
})
//====================date Filter ==========================//
  console.log(approveRequestPermission,createRequestPermission,issueRequestPermission,directIssueRequestPermission)


  const getVehicleId = (data,btnType) => {
    if (data !== null) {
      console.log(data);
      setVehicleId(data.number);
      if(!btnType){
        setDeviceId(data.id);

      }
      setTankerCapacityvalue(data.fuelTankCapacity);
      setCurrentFuelValue(data.currentFuelValue)
    } else {
      setDeviceId();
      setVehicleId();
      setTankerCapacityvalue("")
      setCurrentFuelValue("")

    } 
   
  };

  function onSubmitHandler() {
    getRequestList(true);
  }

  const getDateFilter = (event) => {
    console.log(event.target.value);
    if (event.target.name == "fromDate") {
      setFromDate(moment(event.target.value).format("YYYY-MM-DD"));
    } else if (event.target.name == "toDate") {
      setToDate(moment(event.target.value).format("YYYY-MM-DD"));
    } else if (event.target.name == "fromDateForModal") {
      setFromdateForModal(moment(event.target.value).format("YYYY-MM-DD"));
    }
  };

  function resetAllInput() {
    setApprovedFuel("");
    setTankerCapacity("");
    setCurrentFuel("");
    setVehicleId("");
    setRequestedFuel("");
    setTankerCapacity("");
    setRemarkValue("");
    setIssuedFuel( )
    setOpenAlert(false);
    setDeviceId(null);
    setPageNo(0);
    setPageSize(10);
  }
  const openExcelImportModal = (typestatus, index, row) => {
    console.log(row);
    if (typestatus == "createRequeste") {
      setPageNo(0)
      setPageSize(10)
      setOpenAlert(true);
    }
    if (typestatus == "createIssue") {
      setPageNo(0)
      setPageSize(10)
      setOpenAlert(true);
    }
    if (typestatus == "Reject") {
      setSelectedRow(row);
      setOpenAlert(true);
    }
    if (typestatus == "Approve") {
      setSelectedRow(row);
      setOpenAlert(true);
    }
    if (typestatus == "Issue") {
      setSelectedRow(row);
      setOpenAlert(true);
    }
    if (typestatus == "sync") {
      setSelectedRow(row);
      setOpenAlert(true);
    }
    setType(typestatus);
  };
  const handleAlertClose = () => {
    resetAllInput();
  };
  const onConfirmHandler = (Type) => {
    if (Type == "createRequeste") {
      if (vehicleId == "") {
        alert("Please select vehicle");
        return false;
      } else if (RequestedFuel < 0) {
        alert("Invalid Diesel Quantity");
        return false;
      } else if (RequestedFuel > (tankerCapacityvalue-currentFuelValue)) {
        alert(`Requested fuel cannot be greater than ${tankerCapacityvalue-currentFuelValue}`);
        return false;
      } else if (RequestedFuel == "") {
        alert("Enter your Diesel");
        return false;
      } else if (Remarkvalue == "") {
        alert("Enter your Remark");
        return false;
      }
      createDieselRequest(Type);
      resetAllInput();

      getRequestList(true,"");

      // setPageNo(0);
      // setPageSize(10)
      // setSiteIdBool(true);
    }
    if (Type == "Reject") {
      // alert("Are you sure want to reject this Diesel request? ")
      updateRequestStatus(Type);

      resetAllInput();
      getRequestList(true,"");


    }
    if (Type == "Approve") {
      if (approvedFuel == "") {
        alert("Enter your ApprovedFuel");
        return false;
      } else if (approvedFuel > selectedRow.requestedFuelQuantity) {
        alert("Approved Fuel Quantity can not be greater than requested fuel");
        return false;
      } else if (Remarkvalue == "") {
        alert("Enter your Remark");
        return false;
      }
      updateRequestStatus(Type);

      resetAllInput();
      getRequestList(true,"");


    }
    if (Type == "Issue") {
      if (issuedFuel == "") {
        alert("Enter your IssuedFuel");
        return false;
      } else if (issuedFuel > selectedRow.approvedFuelQuantity) {
        alert("Issue fuel Quantity can not be greater than approved fuel");
        return false;
      }
      if (Remarkvalue == "") {
        alert("Enter your Remark");
        return false;
      }
      updateRequestStatus(Type);

      resetAllInput();
      getRequestList(true,"");


    }
    if (Type == "sync") {
    
      if (Remarkvalue == "") {
        alert("Enter your Remark");
        return false;
      }
      syncIssued(Type);

      resetAllInput();
      getRequestList(true,"");


    }

    if (Type == "createIssue") {
      
      if (Remarkvalue == "") {
        alert("Enter your Remarkvalue");
        return false
      }else if(issuedFuel<=0){
        
        alert("Invalid Fuel Quantity!")
   
        return false
     } 
     else if(issuedFuel>(tankerCapacityvalue-currentFuelValue)){
   
      alert(`Issue Quantity cannot be greater than ${tankerCapacityvalue-currentFuelValue}`)
      
      return false
   } 
      
      createDieselRequest(Type);
      //debugger
      // setPageNo(0);
      // setPageSize(10)
      // setSiteIdBool(true);
      resetAllInput();setDeviceId(null);
      setVehicleId("")
      getRequestList(true,"");


    }
  };

  const excelImport = () => {
    setOpenExcelImport(true);
  };

  const TopviewData = {
    title: `Request Diesel Listing`,
    subTitleFirst: "Dashboard >",
    subTitleSecond: "Request Diesel Listing ",
    //subTitleThird: ` Diesel_issue`,
    // buttonIcon: false,
    // buttonText: " Add ",
    // ButtonClick: "onAddUser",
    backPath: "/fuelDashboard",
    backPathSecond: "/fuelDashboard",
  };
  // -----------------TablePagination function Start ---------------- //
  const handleChangePage = (event, newPage) => {
    console.log(newPage);
    setPageNo(newPage);
    // fetchUserList();
    //getRequestList(true,"");
    setSiteIdBool(true);
  };

  const handleChangeRowsPerPage = (event) => {
    console.log(event.target.value);
    setPageSize(parseInt(event.target.value, 10));
    setPageNo(0);
    setSiteIdBool(true);
  };

  // -----------------TablePagination function End ----------------*//

/* ===========================VEHICLE TYPE LIST================================== */
  const fetchVehicleTypeList = () => {
    VehicleAction.vehicleTypeList().then((response) => {
      ////debugger;
      if (response != null) {
        console.log(response);
        setVehicleTypeList(response);
        // setPageNo(0);
        // setPageSize(10)
      } else {
        setSiteList([]);
      }
    });
  }
/* ===========================VEHICLE TYPE LIST================================== */

  // =============fetch vehicle list for dropdown==============================

  const fetchVehicalList = () => {
    setIsLoading(true);
    let sideIds = [];
    if (
      JSON.parse(localStorage.getItem("data")).sites &&
      JSON.parse(localStorage.getItem("data")).sites.length > 0
    ) {
      JSON.parse(localStorage.getItem("data")).sites.forEach((element) => {
        sideIds.push(element.id);
      });
    }
    VehicleAction.fetchVehicleList({
      pageNo: 0,
      pageSize: 0,
      companyId: JSON.parse(localStorage.getItem("data")).companyId,
      number: "",
      vehicleType: vehicleTypeId?vehicleTypeId.id:"",
      driver: "",
      siteIds: sideIds,
      siteId: siteId ? siteId : "",
      userId: JSON.parse(localStorage.getItem("data")).id,
      allVehicle: true,
      fuelSensorEnabled: true,
    }).then((response) => {
      if (response != null) {
        console.log(response);
        setVehicleList(response);
        setIsLoading(false);
      } else {
        setIsLoading(false);
        setVehicleList([]);
      }
    });
  };

  //  ============= end fetch vehicle list for dropdown==============================

  // =============fetch Site list for dropdown======================================
  const fetchSiteList = () => {
    SiteAction.fetchSiteList({
      companyId: JSON.parse(localStorage.getItem("data")).companyId,
    }).then((response) => {
      ////debugger;
      if (response != null) {
        console.log(response);
        setSiteList(response);
      } else {
        setIsLoading(false);
        setSiteList([]);
      }
    });
  };

  // ============= End fetch Site list for dropdown======================================

  useEffect(() => {

    fetchSiteList();
    fetchVehicalList();
    //getRequestList(true,"");
    if (true) {
          getRequestList(true,"");
        }
        setSiteIdBool(false);
  }, [siteId, siteIdBool,vehicleTypeId]);

  useEffect(()=>{
    fetchVehicleTypeList()

  },[])

  // useEffect(() => {
  //   fetchVehicalList();
  //   if (siteIdBool) {
  //     getRequestList("", "", "", true);
  //   }
  //   setSiteIdBool(false);
  // }, [siteIdBool]);

  /* ==================Filter data as per permission and request Status===================== */

  const filterPermissionData = (data) => {
    console.log(data);
  };
  /* ===================END================================================================= */







  /* ====================EXPORT DATA================================================================= */


  let labelHeader = [
    "S. No",
    "Vehicle Number",
    "Site",
    "Status",
    "Req. Qty",
    "Req. Remark",
    "Req. By",
    "Approved Qty",
    "Approved Remark",
    "Approved By",
    "Issued Qty",
    "Issued Remark",
    "Issued By",
   
    `${JSON.parse(localStorage.getItem("data")).userType==="ADMIN"?"Actual Issued Qty":""}`,
    "Manual Sync",
    "Sync Remark",
    // "Requested Qty/Requester",
    // "Approved Qty/Approver",
   
  ];
  const getExportData = (type) => {
    getRequestList(false, type);
  };



  const exportDataList = (exportArray) => {
    console.log(exportArray)
    let exportDataArray = [];
    exportArray.forEach((ele, index) => {
      console.log(ele,"hgxhsgdfy")
      let objExport = {
        col1: index + 1,
                col2: ele.vehicle.number,
        
                col3: ele.vehicle.site.name,
                col4: ele.fuelFillRequestStatus,
                col5: ele && ele.requestedFuelQuantity?ele.requestedFuelQuantity:"NA",
               col6: ele && ele.requestRemarks?ele.requestRemarks:"NA",

               col7: ele && ele.requestedBy && ele.requestedBy.name? ele.requestedBy.name:"NA",
              col8: ele && ele.approvedFuelQuantity?ele.approvedFuelQuantity:"NA",
              col9:ele && ele.approvedRemarks?ele.approvedRemarks:"NA",
              col10:ele && ele.approvedBy && ele.approvedBy.name?ele.approvedBy.name:"NA",
              col11:ele && ele.issuedFuelQuantity? ele.issuedFuelQuantity:"NA",
              col12:ele && ele.issuedRemarks?ele.issuedRemarks:"NA",
              col13:ele && ele.issuedBy && ele.issuedBy.name? ele.issuedBy.name:"NA",

              col14:JSON.parse(localStorage.getItem("data")).userType==="ADMIN" && ele.actualIssuedQauntity?ele.actualIssuedQauntity:"NA",
              col15:ele && ele.isManualSynced? "Yes":"No",
              col16:ele && ele.manualSyncedRemarks? ele.manualSyncedRemarks:"NA"
        
      
          
      };
      exportDataArray.push(objExport);
    });
    setExportDataPdf(exportDataArray);

    let objExport = {};

    labelHeader.forEach((element, index) => {
      objExport[`col${index + 1}`] = element;
    });

    if (exportDataArray.length > 0) {
      exportDataArray = [objExport].concat(exportDataArray);
    }

    setExportData(exportDataArray);
  };
  /* ===================================END EXPORT DATA=========================================== */



  /* ========================SYNC ISSUED DIESEL=================================================== */



  function syncIssued(btnType) {
    let payloadarray = [];
    let companyId = JSON.parse(localStorage.getItem("data")).companyId;
    let userId = JSON.parse(localStorage.getItem("data")).id;

    let requestRoute = config.apiName.DieselIssuedSync
      // btnType == "createRequeste"
      //   ? `${config.apiName.DieselRequestCreate}`
      //   : btnType == "Approve" || btnType == "Reject" || btnType=="sync"
      //   ? `${config.apiName.DieselRequestApprove}`
      //   : btnType == "Issue"
      //   ? `${config.apiName.DieselRequestIssue}`
      //   : "";

    let data = {
      userId: userId,
      companyId: companyId,
      vehicleId: selectedRow ? selectedRow.vehicle.id : null,
      requestedFuelQuantity: selectedRow
        ? selectedRow.requestedFuelQuantity
        : null,
      requestRemarks:null,
      fuelFillRequestStatus:
        btnType == "Approve"
          ? "APPROVED"
          : btnType == "Issue" || btnType=="sync"
          ? "ISSUED"
          : btnType == "Reject"
          ? "REJECTED"
          : null,
      approvedFuelQuantity: selectedRow ?selectedRow.approvedFuelQuantity :null,
        
      approvedRemarks: null,
      rejectedRemarks: null,
      issuedFuelQuantity: (btnType=="sync" && selectedRow )?selectedRow.issuedFuelQuantity:null,
      manualSyncedRemarks: btnType == "sync" && Remarkvalue ? Remarkvalue : "",
      fuelFillRequestId: selectedRow ? selectedRow.id : null,
      fuelFillIssueVerification:btnType=="sync" && selectedRow ? selectedRow.fuelFillIssueVerification:""
    };

    console.log(data);

    DieselRequestAction.issuedDieselSync(requestRoute, data)
      .then((response) => {
        console.log(response)
        // setDeviceId(null);
        setPageNo(0);
        setPageSize(10)
        setDeviceId("")
        resetAllInput();
        setisManualSync(true)
        getRequestList(true,"");
      })
      .catch((err) => {
        console.log(err);
      });
  }

  /* ==============================END============================================================ */

  /* =========================GET DIESEL REQUEST LIST OF ALL VEHICLE============================== */

  function getRequestList(type,exportType) {
    //debugger
    console.log(type,exportType)
    setIsLoading(true);
    let companyId = JSON.parse(localStorage.getItem("data")).companyId;
    let userId = JSON.parse(localStorage.getItem("data")).id;

    let data = {
      pageNo: type ? pageNo : 0,
      pageSize: type ? pageSize : 0,
      fromDate: Date.parse(moment(fromdate).startOf("day")) + 19800000,
      toDate: Date.parse(moment(ToDate).endOf("day")) + 19800000,
      userId: userId,
      companyId: companyId,
      vehicleType:vehicleTypeId?{id:vehicleTypeId.id}:{id:""},
      vehicleId: deviceId ? deviceId : null,
      siteId: siteId ? siteId : null,
      requestStatus:verificationStatus?verificationStatus.value:null

    };
    console.log(data);
    DieselRequestAction.diselstatausList(data)
      .then((response) => {
        if (response != null) {
          if(type){
            console.log(response,type,exportType);
            setIsLoading(false);
            filterPermissionData(response.data);
            setTableRowData(response.data);
            setRowsPerPage(10);
            setTotalPages(response.totalElements);
          }
          else if(!type){
            console.log(response,type,exportType);
            exportDataList(response.data);

           if (exportType === "excel") {
          setTimeout(() => {
            document.getElementById("exportDataList").click();
            setIsLoading(false)

          }, 500);
        } else if (exportType === "pdf") {
          setTimeout(() => {
            document.getElementById("exportPdfButton").click();
            setIsLoading(false)

          }, 500);
        }

          }
         
     
          // setIsLoading(false)
        } else {
          setIsLoading(false);
          setTableRowData([]);
         
        }
      })
      .catch((error) => {
        setTableRowData([]);
        setTotalPages(0);
        setIsLoading(false);
        console.log(error.message);
      });
  }
  /* =========================END GET DIESEL REQUEST LIST OF ALL VEHICLE============================== */






  /* =====================CREATE REQUEST FOR DIESEL===================================================== */

  function createDieselRequest(btnType) {
    let payloadarray = [];
    let companyId = JSON.parse(localStorage.getItem("data")).companyId;
    let userId = JSON.parse(localStorage.getItem("data")).id;

    let requestRoute =
      btnType == "createRequeste"
        ? `${config.apiName.DieselRequestCreate}`
        : btnType == "Approve"
        ? `${config.apiName.DieselRequestApprove}`
        : btnType == "Issue"
        ? `${config.apiName.DieselRequestIssue}`
        : btnType == "createIssue"
        ? `${config.apiName.DirectIssueRequest}`
        : "";

    let data = {
      userId: userId,
      companyId: companyId,
      vehicleNumber: vehicleId ? vehicleId : null,
      requestedFuelQuantity: RequestedFuel ? +RequestedFuel : null,
      requestRemarks:
        (btnType == "createRequeste" || btnType == "createIssue") && Remarkvalue
          ? Remarkvalue
          : null,
      fuelFillRequestStatus: currentFuel ? currentFuel : null,
      approvedFuelQuantity: approvedFuel ? approvedFuel : null,
      approvedRemarks: btnType == "Approve" && Remarkvalue ? Remarkvalue : null,
      rejectedRemarks: btnType == "Reject" && Remarkvalue ? Remarkvalue : null,
      issuedFuelQuantity: issuedFuelQuantity ? issuedFuelQuantity : null,
      issuedRemarks: btnType == "Issue" && Remarkvalue ? Remarkvalue : null,
    };

    console.log(data);
    // if(btnType=="createRequeste"){
    //   payloadarray.push(data)
    //   console.log(payloadarray)
    // }

    DieselRequestAction.createDieselRequest(requestRoute, data)
      .then((response) => {
        if (response !== null) {
          console.log(response);
          if (response.vehiclesRequestSuccess.length > 0) {
            ////debugger;
            alert("Diesel Issued Successfully!");
            setVehicleId(null);
            setDeviceId(null);
            resetAllInput();
            getRequestList(true,"");

            console.log(deviceId);
          } else if (response.vehiclesAlreadyExist.length > 0) {
            if (response.vehiclesAlreadyExist.includes(vehicleId)) {
              alert("Diesel request for this vehicle is already in Progress !");
              setVehicleId(null);
              setDeviceId(null);
              resetAllInput();

              getRequestList(true,"");
            }
          } else if (response.errorForVehicles.length > 0) {
            // if (response.vehiclesAlreadyExist.includes(vehicleId)) {
              alert("not a valid request");
              setVehicleId(null);
              setDeviceId(null);
              resetAllInput();

              getRequestList(true,"");
            // }
          }
          else{
            resetAllInput()
            getRequestList(true,"")
          }
          console.log(response);
          //alert(" request");
          // setVehicleId(null);
          // setDeviceId(null);
          // resetAllInput();

          // getRequestList(true,"");
        } else {
          // setVehicleId(null);
          // setDeviceId(null);
          resetAllInput();

          getRequestList(true,"");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  /* =====================END CREATE REQUEST FOR DIESEL===================================================== */

  /* =====================APPROVE /ISSUE DIESEL REQUEST===================================================== */

  function updateRequestStatus(btnType) {
    let payloadarray = [];
    let companyId = JSON.parse(localStorage.getItem("data")).companyId;
    let userId = JSON.parse(localStorage.getItem("data")).id;

    let requestRoute =
      btnType == "createRequeste"
        ? `${config.apiName.DieselRequestCreate}`
        : btnType == "Approve" || btnType == "Reject" || btnType=="sync"
        ? `${config.apiName.DieselRequestApprove}`
        : btnType == "Issue"
        ? `${config.apiName.DieselRequestIssue}`
        : "";

    let data = {
      userId: userId,
      companyId: companyId,
      vehicleId: selectedRow ? selectedRow.vehicle.id : null,
      requestedFuelQuantity: selectedRow
        ? selectedRow.requestedFuelQuantity
        : null,
      requestRemarks: Remarkvalue ? Remarkvalue : "",
      fuelFillRequestStatus:
        btnType == "Approve"
          ? "APPROVED"
          : btnType == "Issue" || btnType=="sync"
          ? "ISSUED"
          : btnType == "Reject"
          ? "REJECTED"
          : null,
      approvedFuelQuantity:
        (btnType == "Approve" || btnType=="sync")
          ? approvedFuel
          : selectedRow && selectedRow.approvedFuelQuantity
          ? selectedRow.approvedFuelQuantity
          : null,
      approvedRemarks: btnType == "Approve" && Remarkvalue ? Remarkvalue : "",
      rejectedRemarks: btnType == "Reject" && Remarkvalue ? Remarkvalue : "",
      issuedFuelQuantity: btnType=="sync"?selectedRow.issuedFuelQuantity:   issuedFuel ? issuedFuel : null,
      issuedRemarks: btnType == "Issue" && Remarkvalue ? Remarkvalue : "",
      fuelFillRequestId: selectedRow ? selectedRow.id : null,
      fuelFillIssueVerification:btnType=="sync" && selectedRow ? selectedRow.fuelFillIssueVerification:""
    };

    console.log(data);

    DieselRequestAction.updateDieselRequest(requestRoute, data)
      .then((response) => {
        console.log(response)
        // setDeviceId(null);
        setPageNo(0);
        setPageSize(10)
        setDeviceId("")
        resetAllInput();
        
        getRequestList(true,"");
      })
      .catch((err) => {
        console.log(err);
      });
  }
  const InfoIconApproveOpen = (row) => {
    console.log(row);
    alert(row.approvedRemarks !== null ? row.approvedRemarks : "No Remarks");
  };

  const InfoIconIssueOpen = (row) => {
    console.log(row);
    alert(row.issuedRemarks !== null ? row.issuedRemarks : "No Remarks");
  };

  /* =====================APPROVE /ISSUE DIESEL REQUEST===================================================== */
  let roleObj = {
    actionBy: "",
    quantity: "",
    date: "",
    remarks: "",
  };

  function fetchRelatedDataBasedOnTitle(data, title) {
    ////debugger;
    if (data && title) {
      if (title == "Request Info") {
        // alert("uh")
        roleObj.actionBy =
          data.requestedBy != null &&
          data.requestedBy.name != null &&
          data.requestedBy.name
            ? data.requestedBy.name
            : "NA";
        roleObj.quantity =
          data.requestedFuelQuantity != null && data.requestedFuelQuantity
            ? data.requestedFuelQuantity
            : "";
        roleObj.date =
          data.requestedAt != null && data.requestedAt
            ? moment
                .utc(data.requestedAt, "YYYY-MM-DD HH:mm")
               . zone('+05:30')
                .format("YYYY-MM-DD h:mm A")
            : "";
        roleObj.remarks =
          data.requestRemarks != null && data.requestRemarks
            ? data.requestRemarks
            : "NA";
        console.log(roleObj);
        return roleObj;
      } else if (title == "Approve Info") {
        roleObj.actionBy =
          data.approvedBy != null && data.approvedBy.name != null
            ? data.approvedBy.name
            : data.rejectedBy != null && data.rejectedBy.name != null
            ? data.rejectedBy.name
            : "NA";
        roleObj.quantity =
          data.approvedFuelQuantity != null && data.approvedFuelQuantity
            ? data.approvedFuelQuantity
            : "";
        roleObj.date =
          data.approvedAt != null && data.approvedAt
            ? moment
                .utc(data.approvedAt, "YYYY-MM-DD HH:mm")
                . zone('+05:30')

                .format("YYYY-MM-DD h:mm A")
                : data.rejectedAt != null && data.rejectedAt
                ? moment
                    .utc(data.rejectedAt, "YYYY-MM-DD HH:mm")
                    . zone('+05:30')

                    .format("YYYY-MM-DD h:mm A")
            : "";
        roleObj.remarks =
          data.approvedRemarks != null && data.approvedRemarks
            ? data.approvedRemarks
            :data.rejectedRemarks != null && data.rejectedRemarks
            ? data.rejectedRemarks
            : "NA";
        console.log(roleObj);

        return roleObj;
      } else if (title == "Issue Info") {
        roleObj.actionBy =
          data.issuedBy != null && data.issuedBy.name != null
            ? data.issuedBy.name
            : "NA";
        roleObj.quantity =
          data.issuedFuelQuantity != null && data.issuedFuelQuantity
            ? data.issuedFuelQuantity
            : "";
        roleObj.date =
          data.issuedAt != null && data.issuedAt
            ? moment
                .utc(data.issuedAt, "YYYY-MM-DD HH:mm")
                . zone('+05:30')

                .format("YYYY-MM-DD h:mm A")
            : "";
        roleObj.remarks =
          data.issuedRemarks != null && data.issuedRemarks
            ? data.issuedRemarks
            : "NA";
        console.log(roleObj);

        return roleObj;
      }
      else if(title="Manual Sync Info"){
        roleObj.actionBy= data && data.manualSyncedBy!=null && data.manualSyncedBy.name ? data.manualSyncedBy.name:"NA";
        roleObj.quantity=data && data.issuedFuelQuantity?data.issuedFuelQuantity:"";
        roleObj.date= data && data.manualSyncedAt? moment.utc(data.manualSyncedAt, "YYYY-MM-DD HH:mm").zone('+05:30').format("YYYY-MM-DD h:mm A"): "";
        roleObj.remarks= data && data.manualSyncedRemarks? data.manualSyncedRemarks:"NA";
        return roleObj;
      }
    }
  }
  const infoModalHandler = (e, row, title) => {
    console.log(row,title)

    let t1=row.fuelFillRequestStatus=="REJECTED"?"Rejected Info":title
    setInfoModalTitle(title);
    const infoModalData = fetchRelatedDataBasedOnTitle(row, title);
    // console.log(row,t1,infoModalData,title)
    // setSelectedRow(row);
    setDieselModuleData(infoModalData)
    setOpenInfoModal(true);

    console.log(row);
  };

  const infoModalClose = () => {
    setOpenInfoModal(false);
    // setSelectedRow([]);
    setDieselModuleData([])
    setInfoModalTitle("");
  };
 
  const manuelSyncHandler= (event,row,btnType)=>{
      console.log(row,btnType)
  }
  return (
    <>
      <div className="makeStylesRoot">
        <TopView data={TopviewData} />
        <LoadingComponent isLoading={isLoading} />
        <VehicleAddExcel
          loading={loading}
          setLoading={setLoading}
          openExcelImport={openExcelImport}
          handlemodal={handlemodal}
          getRequestList={getRequestList}
        />
        {
          <DieselInfoModal
            openAlert={openInfoModal}
            infoModalClose={infoModalClose}
            title={infoModalTitle}
            data={dieselModuleData}
          />
        }
        <AlertDialog
          openAlert={openAlert}
          setOpenAlert={setOpenAlert}
          onConfirmHandler={onConfirmHandler}
          handleAlertClose={handleAlertClose}
          VehicleId={vehicleId}
          Diesel={Diesel}
          setDisel={setDisel}
          setVehicleId={setVehicleId}
          tankerCapacity={tankerCapacity}
          setTankerCapacity={setTankerCapacity}
          currentFuel={currentFuel}
          RequestedFuel={RequestedFuel}
          setRequestedFuel={setRequestedFuel}
          approvedFuel={approvedFuel}
          Remarkvalue={Remarkvalue}
          setCurrentFuel={setCurrentFuel}
          setApprovedFuel={setApprovedFuel}
          setRemarkValue={setRemarkValue}
          Type={Type}
          fromdate={fromdate}
          setFromDate={setFromDate}
          vehicleList={vehicleList}
          vehicleId={vehicleId}
          getVehicleId={getVehicleId}
          issuedFuelQuantity={issuedFuelQuantity}
          setiSsuedFuelQuantity={setiSsuedFuelQuantity}
          selectedRow={selectedRow}
          setDeviceId={setDeviceId}
          issuedFuel={issuedFuel}
          setIssuedFuel={setIssuedFuel}
          getRequestList={getRequestList}
          tankerCapacityvalue={tankerCapacityvalue}
          getDateFilter={getDateFilter}
          fromdateForModal={fromdateForModal}
          currentFuelValue={currentFuelValue}
          

          //handlersubmit={()=>handlersubmit(typestatus)}
        />

        <Grid
         
          sx={12}
          container
          direction="row"
          justifyContent="flex-end"
          spacing={2}
          alignItems="center"
        >
         <Grid
            items
            sx={2}
            style={{ position: "relative", top: "-50px", right: "35px" }}
          >
            <Button
            style={{
              marginLeft: "1rem",
              // position: "absolute",
              // top: "13px",
              // right: "287px",
            }}
            variant="contained"
            onClick={(event) => getExportData("excel")}
          >
            Export Excel
          </Button>
        
          </Grid>
           <Grid
            items
            sx={2}
            style={{ position: "relative", top: "-50px", right: "35px" }}
          >
             <Button
            style={{
              marginLeft: "1rem",
              // position: "absolute",
              // top: "13px",
              // right: "417px",
            }}
            variant="contained"
            onClick={(event) => getExportData("pdf")}
          >
            Export pdf
          </Button>
           
          </Grid>
          
          <div style={{ display: "none" }}>
            <ExportReport
              exportData={exportData || []}
              labelHeader={labelHeader || []}
              exportHeading={["Diesel Request"]}
            />
            <ExportPdf
              exportData={exportDataPdf || []}
              labelHeader={labelHeader || []}
              title="Diesel Request"
              reportName="Diesel Request"
            />
          </div>
          <Grid
            items
            sx={2}
            style={{ position: "relative", top: "-50px", right: "35px" }}
          >
            <Button
              variant="contained"
              color="secondary"
              style={{ cursor: "pointer", margin: "0 10px" }}
              onClick={excelImport}
              //onChange={onFIleChange}
            >
              <GetAppIcon /> Import Excel
            </Button>
            <input
              type="file"
              accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              id="inputFile"
              name="dieselRequest"
              style={{ display: "none" }}
              // onChange={onFIleChange}
              // ref={fileRef}
              //onChange={onFIleChange}
            />
          </Grid>
          {createRequestPermission.length > 0 && (
            <Grid
              items
              sx={2}
              style={{ position: "relative", top: "-50px", right: "35px" }}
            >
              <Button
                variant="contained"
                color="secondary"
                style={{ cursor: "pointer", margin: "0 10px" }}
                //onClick={() => approvedopen("CreateRequest")}
                onClick={() => openExcelImportModal("createRequeste")}
              >
                Create Request
              </Button>
            </Grid>
          )}
          {directIssueRequestPermission.length > 0 && (
            <Grid
              items
              sx={2}
              style={{ position: "relative", top: "-50px", right: "35px" }}
            >
              <Button
                variant="contained"
                color="secondary"
                style={{ cursor: "pointer", margin: "0 10px" }}
                //onClick={() => approvedopen("CreateRequest")}
                onClick={() => openExcelImportModal("createIssue")}
              >
                Direct Issue
              </Button>
            </Grid>
          )}
        </Grid>
        <Container>
        <div>
            <div
            className="headerTimedate"
            >
              <Grid  container
              // direction="row"
              justifyContent="flex-end"
              spacing={2}
              alignItems="center"
              
              // items
              // xs={12}
              >

            
              <Grid  item spacing={3} container alignContent="center" justifyContent="flex-end" xs={11}  >
                <EnhancedTableToolbar
                  numSelected={selected.length}
                  getdate={getdate}
                  getVehicleId={getVehicleId}
                  getDateFilter={getDateFilter}
                  vehicleList={vehicleList}
                  vehicleId={vehicleId}
                  fromdate={fromdate}
                  ToDate={ToDate}
                  onSubmitHandler={onSubmitHandler}
                  setDeviceId={setDeviceId}
                  siteList={siteList}
                  getSiteID={getSiteID}
                  getVehicleTypeId={getVehicleTypeId}
                  vehicleTypeId={vehicleTypeId}
                  vehicleTypeList={vehicleTypeList}
                  siteId={siteId}
                  getStatusValue={getStatusValue}
                  verificationStatusArray={verificationStatusArray}

                />
              </Grid>
              <Grid
                item
               xs={1}
              //  flex-basis="5.333333%"
                style={{
                // textAlign:"right",
                  // marginLeft:".5rem",
                }}
              >
                <Typography variant="subtitle2">
                  <Button
                    variant="contained"
                    color="secondary"
                    id="mainSubmit"
                    style={{ cursor: "pointer" }}
                    onClick={onSubmitHandler}
                  >
                    Submit
                  </Button>
                </Typography>
              </Grid>
              </Grid>
            </div>
          </div>
          {viewDieselRequestPermission.length > 0 && (
            <Paper className={classes.paper} id="left">
              <div style={{ marginTop: "20px", backgroundColor: "white" }}>
                <TableContainer>
                  <Table>
                    <EnhancedTableHead />
                    <TableBody>
                      {tablerowdata.length > 0 &&
                        tablerowdata.map((row, index) => {
                          return (
                            <TableRow
                              hover
                              role="checkbox"
                              key={index}
                              style={{
                                background:
                                  JSON.parse(localStorage.getItem("data"))
                                    .userType == "ADMIN" &&
                                  row.fuelFillIssueVerification == "CONFIRMED"
                                    ? "rgb(190 235 190)"
                                    : JSON.parse(localStorage.getItem("data"))
                                        .userType == "ADMIN" &&
                                      row.fuelFillIssueVerification ==
                                        "UNACEPTABLE"
                                    ? "#dc3b3580"
                                    : JSON.parse(localStorage.getItem("data"))
                                        .userType == "ADMIN"
                                    ? "rgb(255 255 0 / 11%)"
                                    : "",
                              }}
                              onClick={(event, row) => {
                                rowSelectHandler(event, row);
                              }}
                            >
                              <TableCell> {index + 1} </TableCell>
                              <TableCell style={{ maxWidth: "150px" }}>
                                {row.vehicle.number}
                              </TableCell>
                              <TableCell style={{ maxWidth: "100px" }}>
                                {" "}
                                {row.vehicle.site.name}
                              </TableCell>
                              <TableCell>{row.fuelFillRequestStatus}</TableCell>
                              <TableCell>
                                {row.issuedFuelQuantity
                                  ? row.issuedFuelQuantity
                                  : "NA"}
                              </TableCell>

                              {JSON.parse(localStorage.getItem("data"))
                                .userType == "ADMIN" && (
                                <TableCell>
                                  {row.actualIssuedQauntity
                                    ? row.actualIssuedQauntity
                                    : "NA"}
                                </TableCell>
                              )}

                              {/* 
                            <TableCell>
                              {moment(row.requestedAt).format(
                                "DD-MM-YYYY HH:MM"
                              )}
                            </TableCell> */}
                              <TableCell style={{ maxWidth: "100px" }}>
                                {row.fuelFillRequestStatus == "REQUESTED" ||
                                row.fuelFillRequestStatus == "APPROVED" ||
                                row.fuelFillRequestStatus == "ISSUED" ? (
                                  <Button
                                    variant="contained"
                                    className="py-0"
                                    onClick={(e) =>
                                      infoModalHandler(e, row, "Request Info")
                                    }
                                  >
                                    info
                                  </Button>
                                ) : (
                                  "NA"
                                )}
                              </TableCell>
                              <TableCell style={{ maxWidth: "100px" }}>
                                {row.fuelFillRequestStatus == "APPROVED" ||
                                row.fuelFillRequestStatus == "ISSUED" ||
                                row.fuelFillRequestStatus == "REJECTED" ? (
                                  <Button
                                    variant="contained"
                                    className="py-0"
                                    onClick={(e) =>
                                      infoModalHandler(e, row, "Approve Info")
                                    }
                                  >
                                    info
                                  </Button>
                                ) : (
                                  "NA"
                                )}
                              </TableCell>
                              <TableCell style={{ maxWidth: "100px" }}>
                                {row.fuelFillRequestStatus == "ISSUED" ? (
                                  <Button
                                    variant="contained"
                                    className="py-0"
                                    onClick={(e) =>
                                      infoModalHandler(e, row, "Issue Info")
                                    }
                                  >
                                    info
                                  </Button>
                                ) : (
                                  "NA"
                                )}
                              </TableCell>

                              <TableCell style={{ width: 200 }}>
                                {/* {row.approvedFuelQuantity ? 
                              (<span>
                                {row.approvedFuelQuantity}  <InfoIcon style={{width:"15px",color:"rgb(0 171 255)"}} onClick={()=>InfoIconApproveOpen(row)}/></span>
                              ) 
                          
                              : */}
                                {row.fuelFillRequestStatus == "REQUESTED" &&
                                  approveRequestPermission.length > 0 && (
                                    <div>
                                      <StatusButton
                                        btnType="Approve"
                                        openExcelImportModal={() =>
                                          openExcelImportModal(
                                            "Approve",
                                            index,
                                            row
                                          )
                                        }
                                        Type={Type}
                                      >
                                        Approve
                                      </StatusButton>

                                      <StatusButton
                                        btntype="Reject"
                                        openExcelImportModal={() =>
                                          openExcelImportModal(
                                            "Reject",
                                            index,
                                            row
                                          )
                                        }
                                        Type={Type}
                                      >
                                        Reject
                                      </StatusButton>
                                    </div>
                                  )}

                                {/* {row.issuedFuelQuantity
                                ? <span>{row.issuedFuelQuantity}<InfoIcon style={{width:"15px",color:"rgb(0 171 255)"}} onClick={()=>InfoIconIssueOpen(row)}/></span>
                                :  */}

                                {issueRequestPermission.length > 0 &&
                                  row.fuelFillRequestStatus == "APPROVED" && (
                                    <StatusButton
                                      btnType="Issue"
                                      openExcelImportModal={() =>
                                        openExcelImportModal(
                                          "Issue",
                                          index,
                                          row
                                        )
                                      }
                                      Type={Type}
                                    >
                                      Issue
                                    </StatusButton>
                                  )}
                                  {
                                    (row.fuelFillIssueVerification=="PENDING" || row.fuelFillIssueVerification=="UNAUTHERIZED") && manualSyncPermission &&
                                    <StatusButton
                                    btnType="sync"
                                    openExcelImportModal={() =>
                                        openExcelImportModal(
                                          "sync",
                                          index,
                                          row
                                        )
                                      }
                                    >Sync</StatusButton>
                                  }
                                  {
                                    manualSyncPermission&&  row.isManualSynced && 
                                    <TableCell style={{ maxWidth: "100px",padding:0}}>
                                {row.isManualSynced ? (
                                  <Button
                                    variant="contained"
                                    className="py-0"
                                    onClick={(e) =>
                                      infoModalHandler(e, row, "Manual Sync Info")
                                    }
                                  >
                                    info
                                  </Button>
                                ) : (
                                  "NA"
                                )}
                              </TableCell>
                                  }
                              </TableCell>
                            </TableRow>
                          );
                        })}
                    </TableBody>
                  </Table>
                </TableContainer>
                <Grid container zeroMinWidth  justifyContent={JSON.parse(localStorage.getItem("data")).userType=="ADMIN" ? "space-evenly":"flex-end"} alignItems="center">
                {JSON.parse(localStorage.getItem("data")).userType=="ADMIN" &&
                <Grid item xs={8} direction="row" container spacing={2} justifyContent="flex-end" zeroMinWidth>
                  <Grid item xs={4} textAlign="right">
                <ColorLabel bgColor="rgb(190 235 190)" labelText="AUTHORIZED(Quantity Matched)" />

                  </Grid>
                  <Grid item xs={4}>
                <ColorLabel bgColor="#dc3b3580" labelText="UNAUTHORIZED(Quantity Unmatched)" />

                  </Grid>
                  <Grid item xs={4}>
                <ColorLabel bgColor="rgb(255 255 0 / 50%)" labelText="PENDING" />

                  </Grid>
                  </Grid>
                }
               

                {/* -----------------TablePagination Start ----------------*/}
                <Grid item xs={4} >
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25]}
                  component="div"
                  count={totalPages}
                  rowsPerPage={pageSize}
                  page={pageNo}
                  onChangePage={handleChangePage}
                  onChangeRowsPerPage={handleChangeRowsPerPage}
                />
                </Grid>
                </Grid>
                
                {" "}
                {/* -----------------TablePagination End ----------------*/}
              </div>
            </Paper>
          )}
        </Container>
      </div>
    </>
  );
};
